module.exports = __webpack_public_path__ + "img/sch5-intro-mg2.1a4040bd.png";